export default __webpack_public_path__ + "static/media/HDTX_Ringkasan Risalah RUPS 24 Juni 2024.4f793bff.pdf";